(() => {
    if (window.__bssNTObserverReady) return;
    window.__bssNTObserverReady = true;

    let reinitTimer;

    function reinitNT() {
        if (window.BSS_B2B?.nt?.initFunction) {
        window.BSS_B2B.nt.initFunction();
        document.dispatchEvent(new Event("bss_b2b:dom_ready"));
        }
    }

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType !== 1) continue;

                const hasNTWrapper =
                    node.id === 'bss-b2b-net-term-button-wrapper' ||
                    node.querySelector?.('#bss-b2b-net-term-button-wrapper');

                if (hasNTWrapper) {
                    clearTimeout(reinitTimer);
                    reinitTimer = setTimeout(reinitNT, 200);
                    return;
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();
